import {Component, EventEmitter, HostListener, Output} from '@angular/core';

@Component({
    selector: 'vui-autocomplete-input-dropdown-option',
    templateUrl: './autocomplete-input-dropdown-option.component.html',
    styleUrls: ['./autocomplete-input-dropdown-option.component.scss']
})
export class AutocompleteInputDropdownOptionComponent {
    @Output() clicked$: EventEmitter<MouseEvent>;

    constructor() {
        this.clicked$ = new EventEmitter<MouseEvent>();
    }

    @HostListener('click', ['$event'])
    public click(mouseEvent: MouseEvent): void {
        this.clicked$.emit(mouseEvent);
    }
}
